import { useRefinementList } from 'react-instantsearch';
import Dropdown, {
  Footer,
  List,
} from '@monofront/design-system/components/Dropdown';
import { ALGOLIA_INSIGHTS_EVENT_NAME } from '@monofront/business/constants';
import { AlgoliaFacets } from '@monofront/types';

type FilterProps = {
  attribute: AlgoliaFacets;
  title: string;
  isToggled?: boolean;
};

const Filter: React.FC<FilterProps> = ({ attribute, title }) => {
  const { items, refine, sendEvent } = useRefinementList({
    attribute,
  });

  if (items.length === 0) {
    return null;
  }

  const currentRefinements = items.filter((item) => item.isRefined);

  return (
    <Dropdown
      label={title}
      selectedItemsCount={currentRefinements.length}
      onReset={() => currentRefinements.forEach((item) => refine(item.value))}
      dropdownItems={items.map((item) => ({
        id: item.value,
        children: (
          <>
            <span
              className={`
              tw-overflow-hidden
              tw-text-ellipsis
              tw-whitespace-nowrap
            `}
              title={item.label}
            >
              {item.label}
            </span>
            <span
              className={`
              tw-lf-counter-badge
              tw-lf-counter-badge-ghost
              tw-ml-1
              tw-mr-4
            `}
            >
              {`(${item.count})`}
            </span>
          </>
        ),
        defaultChecked: item.isRefined,
        onItemClick: () => {
          refine(item.value);

          if (item.value.length > 0) {
            // Not in the doc™️, but `click` forwards a `clickedFilters` event to insights
            // See instantsearch.js/src/lib/utils/createSendEventForFacets.ts
            // TODO: [algolia] not sending event
            sendEvent(
              'click',
              item.value,
              ALGOLIA_INSIGHTS_EVENT_NAME.FILTER_CLICKED,
            );
          }
        },
      }))}
    >
      <List />
      <Footer />
    </Dropdown>
  );
};

export default Filter;
